module.exports = __webpack_public_path__ + "img/coverLogo4.cafad579.jpg";